define('modules/start/products/trans/logobutton/view',['require','exports','module','env','../../base/logobutton/view','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseView = require("../../base/logobutton/view");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        privateUrl: Config.transUrl,
        defaultDomain: Config.defaultDomain,
        serviceName: 'transaccionales',
        logoName:'email-transaccional',
        events: {
            "click .redirect-btn": "redirect",
            "click .activate-btn": "activateAction"
        },

        initialize: function() {
            if(this.productDetails) {
                this.listenTo(this.productDetails, "sync", this.render);
            }
        },

        serialize: function() {
            return {
                active: this.active,
                logoName: 'email-transaccional',
                isStarter: this.checkIfAccountIsStarter()
            };
        },

        checkIfAccountIsStarter: function () {
            return this.servicePlan === 'starter';
        },

        redirect: function() {
            window.location = this.privateUrl + '/?companyId=' + this.companyId;
        }
    });

    module.exports = Layout;
});

